import { apiToken, assignAssistantToWhatsappNumberUrl, whatsappNumberById, whatsappNumberUrl } from "../config";

// create whatsapp number start
export const createWhatsappNumber = async (data) => {
    try {
        const response = await fetch(whatsappNumberUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify(data)  
        });
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Failed to create whatsapp number");
        }
        return res;
    } catch (error) {
        console.error(error);
        throw new Error(error.message || "Failed to create whatsapp number");
    }
}
// create whatsapp number end

// get all whatsapp numbers start
export const getAllWhatsappNumbers = async () => {

    try {
        const url = new URL(whatsappNumberUrl);
        // if (organizationId) {
        //     url.searchParams.set('organizationId', organizationId);
        // }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
        });
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Failed to get all whatsapp numbers");
        }
        return res;
    } catch (error) {
        console.error(error);
        throw new Error(error.message || "Failed to get all whatsapp numbers");
    }
}
// get all whatsapp numbers end

// delete whatsapp number start 
export const deleteWhatsappNumber = async (whatsappNumberId) => {
    try {
        const response = await fetch(whatsappNumberById(whatsappNumberId), {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
        });
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Failed to delete whatsapp number");
        }
        return res;
    } catch (error) {
        console.error(error);
        throw new Error(error.message || "Failed to delete whatsapp number");
    }
}
// delete whatsapp number end

// reassign assistant to whatsapp number start
export const reassignAssistantToWhatsappNumber = async (whatsappNumberId, assistantId) => {
    try {
        const response = await fetch(assignAssistantToWhatsappNumberUrl(whatsappNumberId), {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            },
            body: JSON.stringify({ assistantId })  
        });
        const res = await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Failed to reassign assistant to whatsapp number");
        }
        return res;
    } catch (error) {
        console.error(error);
        throw new Error(error.message || "Failed to reassign assistant to whatsapp number");
    }
}
// reassign assistant to whatsapp number end